import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="copyable"
export default class extends Controller {
  static targets = ["copyable", "icon"]

  connect() {
    if (this.hasIconTarget) {
      // Store the original icon path for reverting later
      this.originalIconPath = this.iconTarget.src
    }
  }

  copy() {
    // Try to get text from data attribute first, then fall back to textContent
    var val = this.copyableTarget.dataset.copyText || this.copyableTarget.textContent.trim()

    // Try modern clipboard API first
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(val).then(() => {
        this.updateIcon()
      }).catch(err => {
        this.fallbackCopy(val)
      })
    } else {
      // Fallback for older browsers or non-secure contexts
      this.fallbackCopy(val)
    }
  }

  fallbackCopy(text) {
    // Create a temporary textarea
    const textArea = document.createElement('textarea')
    textArea.value = text
    textArea.style.position = 'fixed'
    textArea.style.left = '-999999px'
    textArea.style.top = '-999999px'
    document.body.appendChild(textArea)
    textArea.focus()
    textArea.select()

    try {
      document.execCommand('copy')
      this.updateIcon()
    } catch (err) {
      // Copy failed silently
    }

    document.body.removeChild(textArea)
  }

  updateIcon() {
    if (this.hasIconTarget) {
      // look for the "data-complete-icon-path" attribute on this element.
      // if it exists, swap this element's source with that path.
      var completePath = this.iconTarget.dataset.completeIconPath
      if (completePath) {
        this.iconTarget.src = completePath

        // Revert back to original icon after 2 seconds
        setTimeout(() => {
          if (this.hasIconTarget && this.originalIconPath) {
            this.iconTarget.src = this.originalIconPath
          }
        }, 2000)
      }
    }
  }
}
